import React from 'react';

import { UiButton } from '../../ui/ui-button';

export class JobFlowConfirmation extends React.PureComponent<
  JobFlowStep & {
    onCreateAnother: () => void;
    onFinished: () => void;
  }
> {
  render() {
    const { onFinished, onCreateAnother } = this.props;

    return (
      <div className="u-textAlign-center">
        <div className="typo-h5 u-margin-top-2x">Your job is ready to go!</div>
        <div>
          <div className="typo-title u-maxWidth-550px u-display-inlineBlock u-margin-top-2x u-margin-bottom-2x">
            If you skipped a step, you can return to it by clicking the step on the left. Otherwise,
            you can always edit and add more info later.
          </div>
        </div>
        <UiButton
          onClick={onCreateAnother}
          size="lg"
          variant="secondary"
          className="u-margin-right"
        >
          Create another job
        </UiButton>
        <UiButton onClick={onFinished} size="lg">
          I&apos;m Finished
        </UiButton>
      </div>
    );
  }
}
